import { Link } from "react-router-dom";
import { ArrowRight, MessageCircleQuestion } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqs, heroImages } from "@/data/content";

const Faq = () => (
  <div data-testid="faq-page">
    <PageHero
      eyebrow="FAQ"
      lines={["Domande", <span key="i" className="italic text-gold">frequenti</span>]}
      description="Tutto quello che c'è da sapere su crediti NPL e UTP, sui nostri servizi e sul modo in cui lavoriamo."
      image={heroImages.faq}
    />

    <section className="bg-cream py-28" data-testid="faq-list-section">
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        <Reveal>
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-navy/10 bg-white px-7 transition-all duration-300 data-[state=open]:border-gold/60 data-[state=open]:shadow-xl data-[state=open]:shadow-gold/5"
              >
                <AccordionTrigger className="py-6 text-left text-base font-semibold text-navy hover:text-gold-dark hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 leading-relaxed text-navy/60">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.1} className="mt-16">
          <div className="relative overflow-hidden rounded-[2rem] bg-navy p-10 text-center lg:p-14">
            <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-gold/15 blur-3xl" />
            <MessageCircleQuestion size={34} className="mx-auto text-gold" strokeWidth={1.6} />
            <h2 className="relative mt-5 font-display text-3xl text-white lg:text-4xl">Non hai trovato la risposta?</h2>
            <p className="relative mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/60 md:text-base">
              Il nostro team è a disposizione per chiarire ogni dubbio e valutare la tua situazione specifica, in modo riservato e senza impegno.
            </p>
            <Link
              to="/contatti"
              data-testid="faq-contact-cta"
              className="group relative mt-8 inline-flex items-center gap-2 rounded-full bg-gold px-8 py-3.5 text-sm font-semibold text-navy shadow-xl shadow-gold/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-gold-light"
            >
              Fai la tua domanda
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  </div>
);

export default Faq;
